import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { Navbar, Container, FormControl, Nav, NavDropdown, Offcanvas, ListGroup } from "react-bootstrap";
import { Link } from "react-router-dom";
import { db } from "../../firebase/firebaseConfig";
import { collection, getDocs } from "firebase/firestore";
import "./NavigationBar.css";

export function NavigationBar() {
  const [showOffcanvas, setShowOffcanvas] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");
  const [searchResults, setSearchResults] = useState([]);
  const [allProducts, setAllProducts] = useState([]);
  const [categories, setCategories] = useState([]);

  const location = useLocation();

  const handleCloseOffcanvas = () => {
    setSearchTerm('');
    setSearchResults([]);
    setShowOffcanvas(false);
  };

  const handleToggleOffcanvas = () => setShowOffcanvas(!showOffcanvas);

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const productsRef = collection(db, "productos");
        const querySnapshot = await getDocs(productsRef);
        const products = querySnapshot.docs.map((doc) => ({
          id: doc.id,
          ...doc.data(),
        }));
        setAllProducts(products);

        const uniqueCategories = [
          "Todos",
          ...new Set(products.map((product) => product.category)),
        ];
        setCategories(uniqueCategories);
      } catch (error) {
        console.error("Error al obtener los productos:", error);
      }
    };

    fetchProducts();
  }, []);

  const handleSearch = (term) => {
    setSearchTerm(term);
    if (term.trim() === "") {
      setSearchResults([]);
    } else {
      const filteredProducts = allProducts.filter((product) =>
        product.name.toLowerCase().includes(term.toLowerCase())
      );
      setSearchResults(filteredProducts);
    }
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

  return (
    <Navbar expand="lg" className="custom-navbar py-0 fixed-top">
      <Container fluid className="navigation-flexw">
        <Navbar.Brand as={Link} to="/" className="text-center">
          <img src="/logo-nav.png" alt="Logo" className="logo" />
        </Navbar.Brand>

        <Navbar.Toggle
          aria-controls="offcanvasNavbar"
          onClick={handleToggleOffcanvas}
        />

        <Navbar.Offcanvas
          id="offcanvasNavbar"
          aria-labelledby="offcanvasNavbarLabel"
          placement="start"
          className="w-100 d-lg-none"
          show={showOffcanvas}
          onHide={handleCloseOffcanvas}
        >
          <Offcanvas.Header closeButton>
            <Offcanvas.Title id="offcanvasNavbarLabel">
              <img src="/logo-nav.png" alt="Logo" className="logo" />
            </Offcanvas.Title>
          </Offcanvas.Header>

          <Offcanvas.Body>
            <div className="search-container">
              <FormControl
                type="search"
                placeholder="Buscar ..."
                className="search-input"
                aria-label="Buscar"
                value={searchTerm}
                onChange={(e) => handleSearch(e.target.value)}
              />
              <i className="fas fa-search search-icon"></i>

              {searchResults.length > 0 && (
                <ListGroup className="search-results">
                  {searchResults.map((product) => (
                    <ListGroup.Item
                      key={product.id}
                      as={Link}
                      to={`/producto/${product.id}`}
                      onClick={() => {
                        handleCloseOffcanvas();
                        setSearchTerm('');
                      }}
                    >
                      {product.name}
                    </ListGroup.Item>
                  ))}
                </ListGroup>
              )}
            </div>

            <Nav className="flex-column">
              <Nav.Link as={Link} to="/" onClick={handleCloseOffcanvas}>
                Home
              </Nav.Link>
              <NavDropdown title="Productos" id="productos-dropdown">
                {categories.map((category, index) => (
                  <NavDropdown.Item
                    key={index}
                    as={Link}
                    to={category === "Todos" ? "/productos" : `/productos/${category}`}
                    onClick={handleCloseOffcanvas}
                  >
                    {category}
                  </NavDropdown.Item>
                ))}
              </NavDropdown>
              <Nav.Link as={Link} to="/nosotros" onClick={handleCloseOffcanvas}>
                Nosotros
              </Nav.Link>
              <Nav.Link as={Link} to="/contacto" onClick={handleCloseOffcanvas}>
                Contacto
              </Nav.Link>
            </Nav>
          </Offcanvas.Body>
        </Navbar.Offcanvas>

        <Navbar.Collapse className="d-none d-lg-flex justify-content-between align-items-center">
          <div className="search-container">
            <FormControl
              type="search"
              placeholder="Buscar ..."
              className="search-input"
              aria-label="Buscar"
              value={searchTerm}
              onChange={(e) => handleSearch(e.target.value)}
            />
            <i className="fas fa-search search-icon"></i>

            {searchResults.length > 0 && (
              <ListGroup className="search-results">
                {searchResults.map((product) => (
                  <ListGroup.Item
                    key={product.id}
                    as={Link}
                    to={`/producto/${product.id}`}
                    onClick={() => {
                      handleCloseOffcanvas();
                      setSearchTerm('');
                    }}
                  >
                    {product.name}
                  </ListGroup.Item>
                ))}
              </ListGroup>
            )}
          </div>

          <Nav className="nav-links">
            <Nav.Link as={Link} to="/" onClick={handleCloseOffcanvas}>
              Home
            </Nav.Link>
            <NavDropdown title="Productos" id="productos-dropdown">
              {categories.map((category, index) => (
                <NavDropdown.Item
                  key={index}
                  as={Link}
                  to={category === "Todos" ? "/productos" : `/productos/${category}`}
                  onClick={handleCloseOffcanvas}
                >
                  {category}
                </NavDropdown.Item>
              ))}
            </NavDropdown>
            <Nav.Link as={Link} to="/nosotros" onClick={handleCloseOffcanvas}>
              Nosotros
            </Nav.Link>
            <Nav.Link as={Link} to="/contacto" onClick={handleCloseOffcanvas}>
              Contacto
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
}

